<div>
  <main>  
      <router-outlet></router-outlet>    
  </main>
</div>